import React, { useState, useEffect } from 'react'
import { useStateValue } from '../../utilities/StateProvider';
import { Image, Row, Col } from 'react-bootstrap';
import { api } from '../../utilities/fetch';

export default function ExtrasResume() {
    
    const [ { cart, isInterior }, _ ] = useStateValue();
    const [ extras, setExtras ] = useState([]);

    useEffect(() => {
        const getExtras = async () => {
            const extrasList = await api.get(`extras`);
            setExtras(extrasList.data);
        }
        getExtras();

    }, [])

    const renderExtras = () => {
        const filteredExtras = extras
            .filter(entry => cart[entry.slug])
            .map(entry => ({...entry, image: cart[entry.slug].image}));

        if (!filteredExtras.length) {
            return (<div className="extra-resume">N/A</div>);
        }

        return filteredExtras.map(entry => (
            <Col xs="4" className="extra-resume">
                <div>
                    <Image src={entry.image} height={150} />
                    <div className="price">{`$${!isInterior ? entry.meta.price : entry.meta.price_interior}`}</div>
                </div>
                <div className="title">{entry.title.rendered}</div>
            </Col>
        ))
    }

    if (!extras.filter(entry => cart[entry.slug]).length) {
        return null;
    }

    return (
        <React.Fragment>
            <Col xs="12 title">Extras</Col>
            <Col xs="12" md={{offset: 2, span: 8}}>
                <Row>
                    {renderExtras()}
                </Row>
            </Col>
        </React.Fragment>
    )
}
